












































helpers = require('../../helpers.coffee')

view_model = {
  data: ->
    group_name: null
    selected_contacts: {}
    loaded_contacts: []
    persisted_selected_contacts: []
    persisted_selected_contact_ids: []
    loading: false
    next_page: 1

  computed:
    contacts_count: ->
      Object.keys(@selected_contacts).length

  methods:
    loadContacts: ->
      return if @loading || !@next_page
      @loading = true
      @filters = @mergeCurrentUserFilter(@filters)
      @contact_resource.withoutGroup @loadSuccess, Loader.off, params: {q: @filters, page: @next_page}

    loadSuccess: (resources) ->
      @loading = false
      @next_page = resources.meta.next_page
      @loaded_contacts = @loaded_contacts.concat(resources.contacts)

    filter: (filters) ->
      @loaded_contacts = []
      @next_page = 1
      @filters = filters
      @loadContacts()

    createGroup: ->
      return if !@group_name
      Loader.on()
      contacts_ids = Object.values(@selected_contacts).map (x) -> x.id
      @contact_group_resource.post @saveSuccess, @saveFailure, { name: @group_name, contacts: contacts_ids  }
      jQuery("#new-group-modal").modal 'hide'

    saveSuccess: (resource) ->
      self = this
      Loader.off()
      @group_name = null
      alertify.success @$t('contacts_group.feedback.creationSuccess')
      @selected_contacts = {}
      @$emit 'contact-group-saved', resource
      @trackIntercomGroupCreation(resource.contact_group)

    saveFailure: (response) ->
      Loader.off()
      if response.body.name
        alertify.error response.body.name[0]
      else
        alertify.error @$t('contacts_group.feedback.creationProblem')

    updateSelectedContacts: (data) ->
      if data.attr.selected
        Vue.set @selected_contacts, data.attr.contact.id, data.attr.contact
      else
        Vue.delete @selected_contacts, data.attr.contact.id

    resetModal: ->
      @selected_contacts = {}
      @loaded_contacts = []
      @persisted_selected_contacts = []
      @persisted_selected_contact_ids = []
      @next_page = 1
      @loadContacts()

    show: ->
      @resetModal()
      jQuery("#new-group-modal").modal 'show'

    trackIntercomGroupCreation: (contact_group) ->
      metadata = { id: contact_group.id, 'Nome': contact_group.name, 'Quantidade de contatos': contact_group.contacts_count }
      IntercomCtrl.trackEvent(@$t('contacts_group.events.created'), metadata)

  created: ->
    @contact_resource = new ContactsResource Session.current_company.id
    @contact_group_resource = new ContactGroupsResource Session.current_company.id
    @loadContacts()

    EventsBus.$on 'new-group-modal-show', @show

  beforeDestroy: ->
    EventsBus.$off 'new-group-modal-show', @show
}

exports.default = helpers.vue_include(
  view_model, helpers.form,
  helpers.contacts.list_view_modes, helpers.filters
)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contact_groups/new.vue